'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/success/SuccessIcon.tsx
import { jsx } from "react/jsx-runtime";
var SuccessIcon = (props) => /* @__PURE__ */ jsx(
  "svg",
  __spreadProps(__spreadValues({
    width: "8",
    height: "8",
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.82704 0.788301C8.03592 0.968921 8.05883 1.28467 7.87821 1.49355L2.97821 7.16022C2.88703 7.26567 2.75596 7.32827 2.61662 7.3329C2.47729 7.33754 2.34235 7.28379 2.24436 7.18463L0.144361 5.05963C-0.0497425 4.86322 -0.0478693 4.54664 0.148545 4.35254C0.344959 4.15844 0.661536 4.16031 0.855639 4.35672L2.57551 6.09707L7.12179 0.83947C7.30241 0.63059 7.61816 0.607681 7.82704 0.788301Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  SuccessIcon
};
//# sourceMappingURL=chunk-GNQ32QSQ.mjs.map